import clsx from 'clsx';

import type { FC, HTMLAttributes } from 'react';

import s from './TopBarSafeAreaContent.module.css';

type TopBarSafeAreaContentProps = HTMLAttributes<HTMLDivElement>;

const TopBarSafeAreaContent: FC<TopBarSafeAreaContentProps> = ({ className, ...props }) => (
  <div className={clsx(s.content, className)} {...props} />
);

export { TopBarSafeAreaContent };
